const images = {
    image5: require('./square.jpg'),
    image2: require('./triangle.jpg'),
    image3: require('./jj.jpg'),
};

export default images;
